export default __webpack_public_path__ + "static/media/temple.bf19bc4e.png";